import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { classNames } from 'primereact/utils';
import { forwardRef, useContext, useImperativeHandle, useRef } from 'react';
import { LayoutContext } from './context/layoutcontext';
import { useNavigate } from 'react-router-dom';
import milliepayLogo from '@/assets/logos/BMAlandscape.png';
import { logout } from '@/shared/auth/auth.reducer';
// import { getStoredAuth } from '@/shared/auth/auth-storage';
// import { APP_FEATURE_GUARDS } from '@/shared/constants/app-permissions';
// import { useHasAnyAuthority } from '@/shared/auth/use-has-any-authority';
// import { useCrmChatContext } from '@/shared/providers/CrmChatProvider';
import { useAppDispatch } from '@/store';
const AppTopbar = forwardRef((_props, ref) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { layoutState, onMenuToggle, showProfileSidebar, setLayoutState } = useContext(LayoutContext);
    // const { pathname } = useLocation();
    // const { totalUnread, toggleWidget } = useCrmChatContext();
    // const canAccessChat = useHasAnyAuthority(APP_FEATURE_GUARDS.chatAccess);
    // const showChatNav = Boolean(getStoredAuth()) && canAccessChat;
    // const onChatNavClick = () => {
    //     if (pathname === '/crm/chat') return;
    //     toggleWidget();
    // };
    const menubuttonRef = useRef(null);
    const topbarmenuRef = useRef(null);
    const topbarmenubuttonRef = useRef(null);
    useImperativeHandle(ref, () => ({
        menubutton: menubuttonRef.current,
        topbarmenu: topbarmenuRef.current,
        topbarmenubutton: topbarmenubuttonRef.current
    }));
    const onConfigButtonClick = () => {
        setLayoutState((prevState) => ({ ...prevState, configSidebarVisible: true }));
    };
    // const wallboardRead = useHasAnyAuthority(APP_FEATURE_GUARDS.wallboardRead);
    return (_jsxs("div", { className: "layout-topbar", children: [_jsx("div", { className: "layout-topbar-start", children: _jsx("button", { ref: menubuttonRef, type: "button", className: "p-link layout-menu-button layout-topbar-button", onClick: onMenuToggle, children: _jsx("i", { className: "pi pi-bars" }) }) }), _jsx("div", { className: "layout-topbar-center", children: _jsx(Link, { to: "/", className: "layout-topbar-logo", children: _jsx("img", { src: milliepayLogo, alt: "MilliePay" }) }) }), _jsxs("div", { className: "layout-topbar-end", children: [_jsx("button", { ref: topbarmenubuttonRef, type: "button", className: "p-link layout-topbar-menu-button layout-topbar-button", onClick: showProfileSidebar, children: _jsx("i", { className: "pi pi-ellipsis-v" }) }), _jsxs("div", { ref: topbarmenuRef, className: classNames('layout-topbar-menu', { 'layout-topbar-menu-mobile-active': layoutState.profileSidebarVisible }), children: [_jsxs("button", { type: "button", onClick: onConfigButtonClick, className: "p-link layout-topbar-button", children: [_jsx("i", { className: "pi pi-cog" }), _jsx("span", { children: "Settings" })] }), _jsxs("button", { onClick: async () => {
                                    await dispatch(logout()).unwrap();
                                    navigate('/login', { replace: true });
                                }, type: "button", className: "p-link layout-topbar-button", children: [_jsx("i", { className: "pi pi-sign-out" }), _jsx("span", { children: "Logout" })] })] })] })] }));
});
AppTopbar.displayName = 'AppTopbar';
export default AppTopbar;
